import { readFile } from 'fs/promises';
import { Injectable } from '@gitlab-org/di';
import { EmptyFileResolver, FileResolver, ReadFile } from '../../../common/services/fs/file';
import { fsPathFromUri } from '../../../common/services/fs/utils';

@Injectable(FileResolver, [])
export class DesktopFileResolver extends EmptyFileResolver {
  async readFile({ fileUri }: ReadFile): Promise<string> {
    return readFile(fsPathFromUri(fileUri), 'utf8');
  }
}
